import qs from 'qs';

const DataType = {
    namespaced: true,

    state: {
        dataTypeList: [],
    },

    getters: {
        dataTypeList (state) {
            return state.dataTypeList;
        },
    },

    mutations: {
        /**
         * Установить тип данных
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['dataTypeList'] = items;
        },

        /**
         * Обновить тип данных
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['dataTypeList'][index] = item;
        },

        /**
         * Добавить тип данных
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['dataTypeList'].push(item);
        },

        /**
         * Удалить тип данных
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['dataTypeList'] = state['dataTypeList'].filter(iItem => iItem !== item);
        },
    },


    actions: {
        /**
         * Получение данных по типам данных
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getDataTypeList ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.dataType,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по типам данных получены.'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true}),
                    console.log('ERROR IN dataType.js | getDataTypeList: ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по типам данных!'),
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных по типам данных
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveDataType ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.data);

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.dataType,
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Тип данных успешно отредактирован!');
                    // Если сохранение нового
                    } else {
                        data.data.id = response.data[0].id;

                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый тип данных успешно создан!');
                    }
                    resolve(response);
                }).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                    console.log('ERROR IN dataType.js | saveDataType: ' + err);
                    reject(err);
                })
            })
        },

        /**
         * Удаление типа данных
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeDataType ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.item);

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.dataType,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Тип данных успешно удален!'),
                    resolve(response)
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении типа данных!'),
                    console.log('ERROR IN dataType.js | removeDataType: ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default DataType;


// WEBPACK FOOTER //
// ./src/store/modules/dataType.js